import { useMemo, useState } from 'react';

import { CONNECTOR_STATUS_FILTER_VALUES, type ConnectorStatusFilterValue } from '@/entities/connector';

const ALL_CONNECTOR_STATUS_FILTER_VALUES = Object.values(CONNECTOR_STATUS_FILTER_VALUES);

export const useConnectorFilters = () => {
  const [selectedActivation, setSelectedActivation] = useState<string[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<ConnectorStatusFilterValue[]>([]);

  const isActiveParam = useMemo(() => {
    if (selectedActivation.length === 0 || selectedActivation.length === 2) return undefined;
    return selectedActivation[0] === 'active';
  }, [selectedActivation]);

  const statusParam = useMemo(() => {
    if (selectedStatus.length === 0) {
      return ALL_CONNECTOR_STATUS_FILTER_VALUES;
    }

    return selectedStatus;
  }, [selectedStatus]);

  return {
    selectedActivation,
    selectedStatus,
    isActiveParam,
    statusParam,
    setSelectedActivation,
    setSelectedStatus,
  } as const;
};
